var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-center",domProps:{"textContent":_vm._s('Keine Berechtigung für diese Seite.')}})])}
var staticRenderFns = []

export { render, staticRenderFns }